import { Base64ToFileConverterService } from "../services/base64-to-file-converter.service";
import 'froala-editor/js/plugins.pkgd.min.js';
import FroalaEditor from 'froala-editor';
declare let $: any;

export class FroalaEditorConstants {
    // Remove constructor parameter and use static property assignment instead
    static base64ToFileConverterService: Base64ToFileConverterService;

    // Optionally, add a static method to initialize the service
    static initialize(base64ToFileConverterService: Base64ToFileConverterService) {
        FroalaEditorConstants.base64ToFileConverterService = base64ToFileConverterService;
    }

    static froalaOptions: any = {
        key: '0BA3jC10D7A5F5F4E4A3bHIMFF1EWBXIJb1BZLZFh1i1MXQLjE4C3F3A3B4A5A4E3D3H2==',
        charCounterCount: false,
        wordCounterCount: false,
        htmlUntouched: true,
        quickInsertEnabled: false,
        linkAlwaysBlank: true,
        enter: FroalaEditor.ENTER_BR,
        toolbarButtons: {
            'moreText': {
                'buttons': ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'textColor', 'backgroundColor']
            },
            'moreParagraph': {
                'buttons': ['alignLeft', 'alignCenter', 'formatOLSimple', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote']
            },
            'moreRich': {
                'buttons': ['insertLink', 'fontAwesome', 'embedly', 'insertHR']
            },
            'moreMisc': {
                'buttons': ['undo', 'redo', 'spellChecker', 'selectAll']
            }
        },
        lineHeights: {
            Default: '',
            Normal: '0.5',
            Single: '1',
            '1.15': '1.15',
            '1.5': '1.5',
            Double: '2'
        },
        events: {}
    }

    static normalizeContentForFroala(content: any): any {
        if (content) {
            content = content.replace(/ id="[^"]*"/g, '');    // remove all id attributes
            content = content.replace(/<br\b([^>]*)\sstyle="[^"]*"([^>]*)>/g, '<br>');   // remove style attributes from <br> tags only
            // content = content.replace(/ style="[^"]*"/g, '');    // remove all style attributes
            content = content.replace(/’/g, `'`);   // replace smart quotes with regular quotes  
            content = content.replace(/‘/g, `'`);   // replace smart quotes with regular quotes
            content = content.replace(/–/g, `-`);   // replace en dash with hyphen
            content = content.replace(/&nbsp;/g, ' ');   // replace non-breaking space with regular space
            content = content.replace(/&quot;/g, '"');   // replace HTML quotes with regular quotes
            
            content = content.replace(/<div[^>]*>\s*<\/div>/g, '<p><br></p>');   // replace empty <div> tags with <p><br></p>
            content = content.replace(/<div[^>]*>\s*<br[^>]*>\s*<\/div>/g, '<p><br></p>');   // replace <div> with <br> inside with <p><br></p>
            content = content.replace(/<div><br><\/div>/g, '<p><br></p>');    // replace <div><br></div> with <p><br></p>
            content = content.replace(/<div[^>]*>\s*<span[^>]*>\s*<\/span>\s*<\/div>/g, '<p><br></p>');  // replace <div> with <span> inside with <p><br></p>
           
            content = content.replace(/<p[^>]*>\s*<\/p>/g, '<p><br></p>');
            content = content.replace(/<p[^>]*>\s*<br[^>]*>\s*<\/p>/g, '<p><br></p>');
            content = content.replace(/<p><br><\/p>/g, '<p><br></p>');
            content = content.replace(/<p[^>]*>\s*<span[^>]*>\s*<\/span>\s*<\/p>/g, '<p><br></p>');

            content = content.replace(/<span[^>]*>\s*<\/span>/g, '<p><br></p>');
            content = content.replace(/<span[^>]*>\s*<br[^>]*>\s*<\/span>/g, '<p><br></p>');
            content = content.replace(/<span><br><\/span>/g, '<p><br></p>');
        }
        return content;
    }
}